import teamActions from "./teamActions";
import pokedexActions from "./pokedexActions";
import loadActions from "./loadActions";
import buildActions from "./buildActions";
import musicActions from "./musicActions";

const allActions = {
    teamActions, pokedexActions, loadActions, buildActions, musicActions
}

export default allActions;